var _path, _rect, _line, _line2, _line3, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    id: "Stock_cut",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,3V1H3v28   c0,1.105,0.895,2,2,2h22c1.105,0,2-0.895,2-2V3H25z",
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 6,
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    width: 14,
    x: 7,
    y: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 25,
    x2: 25,
    y1: 3,
    y2: 24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 25,
    x2: 25,
    y1: 26,
    y2: 28
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 6,
    x2: 22,
    y1: 15,
    y2: 15
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 6,
    x2: 22,
    y1: 19,
    y2: 19
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 6,
    x2: 18,
    y1: 23,
    y2: 23
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeed);
export default __webpack_public_path__ + "static/media/Feed.601234aa.svg";
export { ForwardRef as ReactComponent };